/** Whether the chart card around a chart is showing its table instead of the drawing.
 *
 * `ChartCard` provides it; a chart reads it with `useChartAsTable()` and, when true, draws only its
 * `ChartTable` (made visible) from the same data. Outside a card it is false, so a chart on its own
 * behaves as before.
 */

import { createContext, useContext } from "react";

export const ChartViewContext = createContext(false);

export function useChartAsTable(): boolean {
  return useContext(ChartViewContext);
}
